<template>
  <li class="flex-shrink-0">
    <button
      @click="select"
      :disabled="props.isDisabled"
      :class="[
        'flex items-center space-x-1 px-4 py-2 text-sm rounded-full transition focus:outline-none',
        props.isActive
          ? 'bg-gradient-to-r from-primary to-secondary text-white ring-2 ring-primary'
          : props.isCompleted
          ? 'bg-transparent text-gray-400 hover:text-gray-600'
          : 'bg-gray-100 text-gray-700',
      ]"
      :aria-current="props.isActive ? 'step' : undefined">
      <span class="font-semibold">{{ props.index + 1 }}.</span>
      <svg
        v-if="props.isCompleted"
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
      </svg>
      <span>{{ props.section.title }}</span>
    </button>
  </li>
</template>

<script setup lang="ts">
import type { Section } from "@/features/progress-stepper/models/Section";

const props = defineProps<{
  section: Section;
  index: number;
  isActive: boolean;
  isCompleted: boolean;
  isDisabled: boolean;
}>();

const emit = defineEmits<{
  (e: "select", idx: number): void;
}>();

function select() {
  if (!props.isDisabled) {
    emit("select", props.index);
  }
}
</script>
